import { format, parse } from 'date-fns';

// Constants
import { TIME_PARSE_REFERENCE } from '../constants';

// Types
import { CreateWorkshopPayload, UpdateWorkshopPayload } from '../../types';
import { WorkshopFormValues } from '../types';

const TIME_FORMAT = 'HH:mm:ss';

export function prepareWorkshopPayload({
  data,
  organizationId
}: {
  data: WorkshopFormValues;
  organizationId: string;
}): CreateWorkshopPayload {
  const location = data.location?.trim();
  const additionalNotes = data.additionalNotes?.trim();

  return {
    organizationId,
    type: 'BUDGETING_BASICS',
    name: data.name.trim(),
    workshopDate: data.workshopDate,
    startTime: data.startTime,
    ...(location ? { location } : {}),
    ...(additionalNotes ? { additionalNotes } : {})
  };
}

export function prepareWorkshopUpdatePayload(
  data: WorkshopFormValues
): UpdateWorkshopPayload {
  const location = data.location?.trim();
  const additionalNotes = data.additionalNotes?.trim();

  return {
    name: data.name.trim(),
    workshopDate: data.workshopDate,
    startTime: data.startTime,
    ...(location ? { location } : {}),
    ...(additionalNotes ? { additionalNotes } : {})
  };
}

/** Formats the stored date/time for display on the summary step. */
export function formatWorkshopDateTime(
  data: Pick<WorkshopFormValues, 'workshopDate' | 'startTime'>
) {
  let formattedDate = '';
  let formattedTime = '';

  if (data.workshopDate) {
    const parsed = parse(data.workshopDate, 'yyyy-MM-dd', TIME_PARSE_REFERENCE);
    if (!Number.isNaN(parsed.getTime())) {
      formattedDate = format(parsed, 'M/d/yyyy');
    }
  }

  if (data.startTime) {
    const parsed = parse(data.startTime, TIME_FORMAT, TIME_PARSE_REFERENCE);
    if (!Number.isNaN(parsed.getTime())) {
      formattedTime = format(parsed, 'h:mm a');
    }
  }

  return { formattedDate, formattedTime };
}
